export default __webpack_public_path__ + "static/media/Xplir_logo_RepPil_vektor_rgb.7d98bc61.svg";